// extracted by mini-css-extract-plugin
module.exports = {"noop":"AngryRedBox_noop__1nCkR","inner":"AngryRedBox_inner__gOulS","label":"AngryRedBox_label__1zlYw"};